import React from "react";
import RecipeCarousel from "./RecipeCarousel";

function Recipe() {
  return (
    <section id="recipes" className="py-5 px-6 bg-white">
      <div className="p-8">
      <RecipeCarousel />
    </div>
    </section>
  );
}

export default Recipe;
